import { Grid, Flex, Box, Text, Image } from "@chakra-ui/react";
import { AmortizationViewModel } from "@common/loans/statements/amortization.view-model";
import { useCustomFormats } from "hooks/useCustomFormat";
import { LoanContext } from "providers/loan";
import { useContext } from "react";
import { Interests } from "./interests";

type HeaderProps = {
  name: "Mortgage Statement" | "Redemption Statement";
  statement: AmortizationViewModel;
};

export function Header({ name, statement }: HeaderProps) {
  const { loan } = useContext(LoanContext);
  const { formatDate } = useCustomFormats();

  if (!loan || !statement) return null;

  return (
    <Flex direction="column" gap={4}>
      <Grid templateColumns="repeat(2, 1fr)">
        {/* Loan information */}
        <Flex direction="column" gap={4}>
          <Flex direction="column">
            <Text color={"black"} fontWeight={"semibold"}>
              {loan.borrower.company.name}
            </Text>
            <Text color={"black"}>{loan.borrower.company.address?.formatted}</Text>
            {loan.location && <Text color={"black"}>{loan.location?.formatted}</Text>}
          </Flex>

          <Flex direction="column">
            <Text color={"black"} fontWeight={"semibold"}>
              Loan Ref #{loan.id.split("-")[0]}
            </Text>
            <Flex gap={1}>
              <Text color={"black"}>{name} as at</Text>
              <Text color={"black"} fontWeight={"semibold"}>
                {formatDate(statement.endAt)}
              </Text>
            </Flex>
          </Flex>
        </Flex>

        {/* Lender logo */}
        <Flex justifyContent={"flex-end"} flex={1}>
          <Box>
            {loan.lender_company?.logo && (
              <Image src={loan.lender_company.logo} maxWidth={"350px"} />
            )}
          </Box>
        </Flex>
      </Grid>

      <Interests statement={statement} />
    </Flex>
  );
}
